import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Label, makeStyles, tokens } from "@fluentui/react-components";
import { Add16Filled } from "@fluentui/react-icons";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/store";
import { checkUserPermission } from "../../../utils";
import { UserPermissionsList } from "../../../config";

import ContentLoader from "../../../components/Loader/ContentLoader";
import ASCButton from "../../../components/Button";

import { getPartnerVulnerabilityListItems } from "../../../redux/Client/Partner/partnerVulnerability";
import NoDataFound from "../../../components/NoDataFound/noDataFound";

const useStyles = makeStyles({
  field: {
    display: "grid",
    gap: tokens.spacingVerticalS,
    marginBottom: tokens.spacingVerticalL,
  },
  wrapper: {
    display: "flex",
    justifyContent: "flex-end",
    margin: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalS} 0`,
  },
});

function PartnerVulnerabilityHomePage(props: any) {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { clientId, itemId, action } = useParams<{
    clientId: string;
    itemId?: string;
    action?: string;
  }>();

  const { activeClient, partnerVulnerability, authUser } = useSelector(
    (state: RootState) => ({
      activeClient: state.activeClient,
      partnerVulnerability: state.partnerVulnerability,
      authUser: state.authUser,
    })
  );

  const styles = useStyles();
  const API_PATH = `/clients/${clientId}/partner/vulnerability`;
  useEffect(() => {
    if (activeClient.basicDetails.associated_with) {
      dispatch(
        getPartnerVulnerabilityListItems(
          activeClient.basicDetails.associated_with
        )
      );
    }
  }, [dispatch, activeClient.basicDetails.associated_with]);

  useEffect(() => {
    const listItems = partnerVulnerability.listItems;

    if (listItems.length > 0 && !itemId) {
      navigate(
        `${API_PATH}/${listItems[0].vulnerability_id}/${action || "view"}`
      );
    }
  }, [navigate, partnerVulnerability.listItems, itemId, action, API_PATH]);

  const canUpdateClient = checkUserPermission(
    authUser,
    UserPermissionsList.ALLOW_UPDATE_CLIENT
  );

  if (partnerVulnerability.loading) {
    return <ContentLoader />;
  }

  if (partnerVulnerability.listItems.length === 0) {
    return (
      <div>
        <div className={styles.wrapper}>
          {canUpdateClient && (
            <ASCButton
              shape="rounded"
              appearance="primary"
              className="asc-button-primary"
              icon={<Add16Filled />}
              size="medium"
              onClick={() => navigate(`${API_PATH}/add`)}
              label="Add New"
            />
          )}
        </div>
        <NoDataFound />
      </div>
    );
  }

  return null;
}

export default PartnerVulnerabilityHomePage;
